import React from 'react'

import { List } from 'components/shared/List/List'
import { TraitScoreCard } from '../../common/TraitScoreCard/TraitScoreCard'
import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { getInterviewScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'
import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'

import styles from './TraitScoreCards.module.scss'

export const TraitScoreCards = ({ scores, traits, language }) => {
  const getSubtraitLabel = subtrait =>
    getTraitTranslation(subtrait, scores?.[subtrait], language)?.label?.[0]

  return (
    <List className={styles.cards} direction="column">
      {traits.map(({ label, trait }) => {
        const subscores = [
          ...TRAITS[trait].map(subtrait => ({
            label: getSubtraitLabel(subtrait),
            score: percentScore(scores?.[subtrait]),
          })),
        ].sort((a, b) => {
          if (b.score < a.score) return -1
          if (a.score < b.score) return 1
          return 0
        })

        return (
          <List.Item className={styles.card} key={trait}>
            <TraitScoreCard
              label={label}
              score={percentScore(scores[trait])}
              subscores={subscores}
              theme={getInterviewScoreTreshholds(scores[trait])}
            />
          </List.Item>
        )
      })}
    </List>
  )
}
